import { API_ENDPOINTS } from "@/constants/api.ts";
import { axiosApiInstance } from "@/libs/axios.tsx";

export const editTutorProfile = async (tutorId: string, section: string, data: FormData | {}) => {
  return axiosApiInstance.post(
    `${API_ENDPOINTS.TUTOR.PROFILE.EDIT_PROFILE}/${tutorId}/${section}?_method=PATCH`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const editTutorProfileSettings = async (data: {}) => {
  return axiosApiInstance.post(
    `${API_ENDPOINTS.TUTOR.PROFILE.EDIT_SETTINGS}/?_method=PATCH`,
    null,
    {
      params: data,
    },
  );
};
